import React from 'react';

/**
 * Teal decorative footer band — appears at the bottom of each internal page.
 * Uses pagina.png as texture; falls back to flat teal.
 */
const PUBLIC = process.env.PUBLIC_URL || '';

const ManCrossPageFooter = () => (
    <div
        className="mgcr-footer-band"
        style={{
            backgroundImage: `url(${PUBLIC}/informs/pie-pagina.png)`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center bottom',
            backgroundSize: '80% auto',
        }}
    />
);

export default ManCrossPageFooter;
